/** A downloadable file row with a colored file-type tile. Used by the portal
 * Homework + Welcome pages. Styles (.filerow/.ftile) live in admin.css. */
const fmtSize = (b?: number): string =>
  b == null || b <= 0 ? "" : b >= 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(b / 1024))} KB`;

function fileType(name: string): { cls: string; label: string } {
  const ext = (name.split(".").pop() ?? "").toLowerCase();
  if (ext === "pdf") return { cls: "pdf", label: "PDF" };
  if (ext === "doc" || ext === "docx") return { cls: "doc", label: ext.toUpperCase() };
  if (ext === "ppt" || ext === "pptx") return { cls: "ppt", label: ext.toUpperCase() };
  if (["png", "jpg", "jpeg", "heic", "gif", "webp"].includes(ext)) return { cls: "img", label: "IMG" };
  return { cls: "file", label: (ext.slice(0, 4) || "FILE").toUpperCase() };
}

export default function FileRow({ name, sizeBytes, onClick }: { name: string; sizeBytes?: number; onClick: () => void }) {
  const t = fileType(name);
  return (
    <button type="button" className="filerow" onClick={onClick} title={`Download ${name}`}>
      <span className={`ftile ${t.cls}`} aria-hidden="true">{t.label}</span>
      <span className="fname">{name}</span>
      {sizeBytes != null && sizeBytes > 0 && <span className="fmeta">{fmtSize(sizeBytes)}</span>}
      <svg className="fdl" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" />
      </svg>
    </button>
  );
}
